import { FormRulesInterface } from './interface';

const rules: FormRulesInterface = {
  spuName: [
    { required: true, message: '请输入商品标题', trigger: 'blur' }
  ],
  selectedName:[
    { required: true, message: '请选中商品类目', trigger: 'blur' },
  ],
  spuSkuImages: [{ required: true, message: '请上传图片', trigger: 'change' }],
  info: [{ required: true, message: '请输入商品详情', trigger: 'change' }],
  brandId: [{ required: true, message: '请选择类目属性', trigger: 'change' }],
  commoditySkuInfo:[{ required: true, message: '请输入价格库存', trigger: 'change' }],
  "serviceInfo.logisticsTempId":[{required: true, message: '请选择运费模板', trigger: 'change'}],
  suggestCostPrice:[{ required: true, message: '请填写供货价（元）', trigger: 'blur' }]
};
export default rules;
